import i18n from '../../../lib/i18n';

enum ChannelType {
    'Venda Direta' = 0,
    'Insumos' = 1,
    'Produto Acabado' = 2,
}

export default ChannelType;

const channelMap: Record<number, string> = {
    [ChannelType.Insumos]: 'Insumos',
    [ChannelType['Produto Acabado']]: 'Produto Acabado',
    [ChannelType['Venda Direta']]: 'Venda Direta',
};

export function getSelectOptionsEnumLoadChannel() {
    const enumOptions: any[] = [];

    const enumStrings = Object.keys(ChannelType).filter(key =>
        Number.isNaN(Number(key)),
    );

    enumStrings.forEach((key: string) => {
        enumOptions.push({
            value: key,
            label: channelMap[ChannelType[key as keyof typeof ChannelType]],
        });
    });

    return enumOptions;
}

export const getLoadChannelOptions = (withAllLabel?: boolean) => {
    let channel = getSelectOptionsEnumLoadChannel();

    channel.forEach(s => {
        s.label = i18n.t(s.label);
        return s;
    });

    if (withAllLabel) {
        channel = [{ value: '', label: i18n.t('All') }, ...channel];
    }

    return channel;
};
